module.exports = __webpack_public_path__ + "static/media/image-3.75c43ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Catalog/image-3.png
// module id = 260
// module chunks = 0